export default {
  views: {
    header: {
      title: "TokenPocket",
      text: "多链数字钱包，DApp、DeFi和NFT的生态入口"
    },
    text: "强大而简单",
    download: "立即下载",
    appStore: "App Store",
    powerful: "强大",
    store: "商店",
    multiChain: "多链",
    enterpriseEdition: "企业版",
    course: "企业版安装教程",
    version: "版本",
    appCourse: "安装教程",
    commonProblem: "常见下载问题",
    beta: "公测版",
    recommend: "推荐",
    getItOn: "下载",
    desc_1: "注：TokenPocket 已限制中国境内用户访问和使用第三方金融应用",
    desc_2: "了解详情",
    desc_3: "下载前请认准官网地址，并警惕网络证书安全性",
    desc_4: "不要相信陌生来电，不要暴露助记词和私钥",
    desc_5: "了解近期骗局 >",
    verifyText: "当前安卓版本:",
    verifyText1: "如何验证应用安全性 >",
    verifyText2: "当前版本",
    verifyText3: "当前 Google Play 版本:"
  },
  common: {
    download: "前往下载"
  },
  ios: {
    desc_1: "多链数字钱包，DeFi、DApp和NFT的生态入口",
    desc_3: "当前仅支持海外AppStore, 没有海外AppStore账号, 请点击前往查看 ",
    desc_2:
      "除基础功能外，Pro版本内置了Dapp商店，支持超过2200款基于EOS、ETH、TRON及IOST底层的Dapp。",
    text_title_1: "什么是TestFlight？",
    text_text_1_1: "TestFlight是苹果公司的一种分发公测版软件的应用",
    text_text_1_2:
      "通过TestFlight用户可以安装TokenPocket Pro版本钱包，与普通的版本相比，Pro版本内置了DApp商店等，功能更丰富。",
    text_title_2: "开始使用TestFlight",
    text_text_2_1: "1. 在iOS设备上点击上方的TestFlight按钮。",
    text_text_2_2: "2. 先获取TestFlight，用于安装Pro版钱包。",
    text_text_2_3: "3. 点击“在TestFlight中查看”或“开始测试”。 ",
    text_title_3: "了解更多关于TestFlight的信息",
    text_text_3: "* 在TestFlight上测试Beta应用"
  }
};
